<template>
  <dv-border-box-8 class="organ" :dur="4" backgroundColor="rgba(8, 50, 78, 0.6)">
    <PartTitle title="明星企业" />
    <dv-scroll-board class="scroll-board" :config="scrollBoardConfig" />
    <div style="height: 10px"></div>
  </dv-border-box-8>
</template>

<script>
import PartTitle from './PartTitle.vue';


export default {
  name: 'Organ',
  components: { PartTitle },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      scrollBoardConfig: {
        data: [

        ],
        rowNum: 2,
        headerBGC: 'none',
        headerHeight: 35,
        oddRowBGC: 'rgba(142,201,255,0.2)',
        evenRowBGC: 'rgba(142,201,255,0.1)',
        waitTime: 2000,
        align: ['center'],
      },
    };
  },
  watch:{
    items: {
      handler(val) {
        if (val.length > 0) {
          const newData = val.map(v=>[v.title]);
          this.scrollBoardConfig = Object.assign({}, this.scrollBoardConfig, {data: newData})
        }
      },
    }
  },

  created() {

  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.organ {
  width: 330px;
  height: 140px;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 8;

  .scroll-board {
    width: 94%;
    height: calc(100% - 60px);
    margin: 0 auto;
  }
}

::v-deep .dv-scroll-board .rows .row-item {
  // margin-bottom: 10px;
  border-radius: 3px;
}
</style>
